import { Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

const ErrorBannerStyles = {
  Component: styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    background-color: ${theme.colors.build.lightLight};
    padding: ${theme.space[6]};
    svg {
        width: 40px;
        height: 40px;
    },
  `,
  Text: styled.div`
    margin-left: ${theme.space[3]};
    line-heigth: ${theme.lineHeights.base};
    font-weight: ${theme.fontWeights.medium};
  `,
  Title: styled(Text)`
    color: #613a53;
    font-size: ${theme.fontSizes['lg']};
  `,
  SubTitle: styled(Text)`
    color: #515151;
    font-size: ${theme.fontSizes['md']};
  `,
};

export default ErrorBannerStyles;
